module.exports = __webpack_public_path__ + "img/logo.e352edf0.svg";